import algoliasearch from "algoliasearch/lite";
import CollectionApi from "../../../../services/api/collectionApi.js";
import FavoriteApi from "../../../../services/api/favoritesApi.js";

const CollectionApiService = new CollectionApi(),
  FavoriteApiService = new FavoriteApi();

export default {
  props: {
    limit: {
      type: Number,
    },
  },

  data() {
    return {
      algoliaClient: algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
        timeouts: {
          connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
          read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
        },
      }),
      searchIndexProducts: null,
      hotListProducts: [],
    };
  },

  methods: {
    getHotListCollection,
    updateProductsForManualCollection,
  },

  mounted() {
    this.searchIndexProducts = this.algoliaClient.initIndex(this.$env.getOrigin() + "_products");
    this.getHotListCollection();
  },
};

function getHotListCollection() {
  const _self = this,
    collectionLimit = 6;

  _self.conditions = [];

  CollectionApiService.getFeaturedCollection()
    .then((response) => {
      if (response.data.product_ids && response.data.product_ids.length) {
        if (_self.limit) {
          response.data.product_ids.splice(_self.limit, response.data.product_ids.length);
        } else {
          response.data.product_ids.splice(collectionLimit, response.data.product_ids.length);
        }

        _self.updateProductsForManualCollection(response.data.product_ids);
      }
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$bugsnagClient.notify(new Error(error));
      }
    });
}

function updateProductsForManualCollection(productIds) {
  const _self = this;

  if (productIds.length) {
    _self.searchIndexProducts
      .getObjects(productIds)
      .then((response, err) => {
        if (err) {
          _self.$swal("Attention", err);
          return;
        }
        const productList = response.results.filter((product) => product);
        if (this.$session.getUserInfo() && this.$session.getUserInfo().role === "RETAILER") {
          FavoriteApiService.getFavoriteProductIds().then((result) => {
            let ids = result.data.product_ids;
            if (ids === undefined) {
              ids = [];
            }
            _self.hotListProducts = productList.map((product) => {
              return {
                ...product,
                is_fav: ids.includes(product.id),
              };
            });
            _self.$forceUpdate();
          });
        } else {
          _self.hotListProducts = productList;
          _self.$forceUpdate();
        }
      })
      .catch((error) => {
        if (error.response) {
          _self.$swal("Attention", error.response.data.error_message);
        } else {
          _self.$bugsnagClient.notify(new Error(error));
        }
      });
  }
}
